import { toast } from 'sonner';
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import {
  useGetPersonalizationProfileListQuery,
  useGetProfileImportStatusQuery,
} from '../../../../../../services/api';
import { PROFILE_LIST_PAGE_SIZE } from './usePersonalizationAgentDefineHandler';

const usePersonalizationAgentValidator = () => {
  const { title, type, collectionId, engineId, requiredFields, profileImport } = useSelector(
    state => state.agent.personalizationAgent
  );

  const importId = profileImport?.importId;
  const importSource = profileImport?.source || 'csv';
  const { data: statusResponse } = useGetProfileImportStatusQuery(importId ?? skipToken);
  const importStatus = statusResponse?.data?.status;
  const isImportCompleted = importStatus === 'completed';

  const { data: listResponse } = useGetPersonalizationProfileListQuery(
    importId && isImportCompleted
      ? {
          page: 1,
          pageSize: PROFILE_LIST_PAGE_SIZE,
          source: importSource,
          importId,
          search: '',
        }
      : skipToken
  );
  const profileCount = listResponse?.data?.totalLength || 0;
  const hasCompletedImport = isImportCompleted && profileCount > 0;

  const isPersonalizationDefineNextButtonDisabled = () => {
    if (!title?.trim()) {
      toast.warning('Enter a name for this agent');
      return true;
    }

    if (!type) {
      toast.warning('Choose who this agent is for');
      return true;
    }

    if (!hasCompletedImport) {
      toast.warning('Import at least one registrant');
      return true;
    }

    return false;
  };

  const isPersonalizationDesignNextButtonDisabled = () => {
    if (!collectionId) {
      toast.warning('Add a collection');
      return true;
    }

    if (!engineId) {
      toast.warning('Add a response engine');
      return true;
    }

    if (!requiredFields?.length) {
      toast.warning('Add at least one recommendation type');
      return true;
    }

    return false;
  };

  return {
    isPersonalizationDefineNextButtonDisabled,
    isPersonalizationDesignNextButtonDisabled,
  };
};

export default usePersonalizationAgentValidator;
